import { http } from '@pendo/http';

export function getJiraInstances () {
    return http.get('/api/s/_SID_/ipaas/solutioninstances/tag/discover-jira').then((res) => res.data);
}

export function getJiraProjects ({ query, ipaasSolutionInstanceId }) {
    const startAt = 0;
    const maxResults = 50;

    return http
        .get(
            `/api/s/_SID_/jira/${ipaasSolutionInstanceId}/project?maxResults=${maxResults}&startAt=${startAt}&query=${query}`,
        )
        .then((res) => res.data);
}

export function getJiraFields ({ projectId, issueTypeId, ipaasSolutionInstanceId }) {
    return http
        .get(`/api/s/_SID_/jira/${ipaasSolutionInstanceId}/project/${projectId}/issueType/${issueTypeId}/field`)
        .then((res) => res.data);
}

export function getJiraServerInfo ({ ipaasSolutionInstanceId }) {
    return http.get(`/api/s/_SID_/jira/${ipaasSolutionInstanceId}/serverinfo`).then((res) => res.data);
}

export function createJiraIssue ({ linkItemId, linkItemType, fields, ipaasSolutionInstanceId }) {
    return http
        .post(`/api/s/_SID_/jira/${ipaasSolutionInstanceId}/issue`, {
            fields,
            linkItemId,
            linkItemType,
        })
        .then((res) => res.data);
}

export function getJiraFieldSuggestions ({ ipaasSolutionInstanceId, fieldName, query = '' }) {
    return http
        .get(`/api/s/_SID_/jira/${ipaasSolutionInstanceId}/field/suggestion?fieldName=${fieldName}&query=${query}`)
        .then((res) => res.data?.results || []);
}

export function searchJiraIssues ({ ipaasSolutionInstanceId, projectIds, query, issueTypes = '' }) {
    return http
        .get(
            `/api/s/_SID_/jira/${ipaasSolutionInstanceId}/issue/picker?query=${query}&projectIds=${projectIds}&issueTypes=${issueTypes}`,
        )
        .then((res) => res.data);
}
